import { IOffer } from '../../offer';

export const getNewbuildingBrokerEnabled = (offer: IOffer) => {
  return offer.newbuildingBroker?.enabled ?? false;
};
